<template>
	<div class="mb-5 no-select" v-cloak>
		<div class="row row-header" v-show="false">
			<div class="col-lg-2"></div>
			<div class="col-lg-8 align-self-center text-center">
				<h1>Free Social Media Bundles</h1>
			</div>
			<div class="col-lg-2"></div>
		</div>

		<div class="row row-main">
			<!-- title -->
			<div class="col-12 text-center">
				<h1 class="my-4">Free Bundle Downloads</h1>
			</div>
			<!-- title -->


			<!-- categories -->
			<div class="col-12 text-center">
				<div class="category-button no-select" :class="classSelected(parentCat.parentCategoryID)" v-for="(parentCat, i) in freebieParentCats" :key="parentCat.parentCategoryID" @click="selectParentCategory(parentCat.parentCategoryID)">
					{{parentCat.parentCategoryName}}&nbsp;({{parentCat.nrFreebies}})
				</div>
			</div>
			<!-- categories -->

			<!-- freebie packages -->
			<div class="col-12">
				<div class="row row-fr-packages justify-content-center">
					<div class="col-sm-12 col-md-6 col-lg-4 col-fr-package" v-for="(oPackage, i) in packages" :key="oPackage.ID">
						<div class="container-fr-package">
							<div class="fr-package-header flex-center">
								<p class="bold">{{oPackage.name}}</p>
							</div>
							<a :href="getProperPackageUrl(oPackage)" target="_blank">
								<img class="fr-package-image" :src="getPreviewImage(oPackage)" />
							</a>
							<div class="flex-center fr-package-cta">
								<p v-show="isOwned(oPackage)"><a :href="getOwnedPackageUrl(oPackage)" target="_blank" title="You own this bundle. Click here to view it.">View In 'My Bundles'</a></p>
								<p class="bold" v-show="isUnowned(oPackage)"><a class="always-underline" :href="getUnownedPackageUrl(oPackage)" target="_blank" title="You don't own this bundle yet. Click here to get it!">Claim This Free Bundle!</a></p>
							</div>
							<div class="ribbon-wrap a-right" v-show="isOwned(oPackage)">
								<div class="ribbon-content"><span>Owned!</span></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- freebie packages -->

			<!-- paginator -->
			<div class="col-12 d-flex justify-content-center mt-2">
				<paginator v-model="pageOptions.pageIndex" v-bind="pageOptions" @paginate="getSelectedPage" :disabled="requestActive" ></paginator>
			</div>
			<!-- paginator -->
		</div>
	</div>
</template>




<script>
	import paginator from './common/Paginator.vue';

	export default {
		mixins: [mixinAxios],
		components: {
			paginator
		},
		data: () => ({
			pageOptions: {
				options: {
					texts: {
						countMultiPage: 'Showing {from} to {to} of {count} free bundles.',
						countSinglePage: '{count} Free bundles.',
						countSingleItem: '1 Free bundle.'
					}
				},
				nrRecords : 0,
				pageSize : 6,
				pageIndex : 0,
				pageSetSize: 10,
				disabled : false
			},
			availableFreebieParentCats: {},
			ownedPackageIDs: {},
			visitorStatus: {},
			wListedPackageIDs: {},
			selectedParentCategoryID: 0,
			packages: []
		}),
		mounted() {
			this.initData();
		},
		methods: {
			initData() {
				this.mixinAxios().get('/api/guest/GetFreebiesOverviewInfo')
					.then((freebiesOverviewInfo) => {
						this.availableFreebieParentCats = freebiesOverviewInfo.data.availableFreebieParentCats;
						this.ownedPackageIDs            = freebiesOverviewInfo.data.ownedPackageIDs;
						this.visitorStatus              = freebiesOverviewInfo.data.visitorStatus;
						this.wListedPackageIDs          = freebiesOverviewInfo.data.wListedPackageIDs;

						this.getFreebiePackagesPaginated();
					});
			},
			getFreebiePackagesPaginated() {
				var params = {
					params: {
						idParentCategory : this.selectedParentCategoryID,
						pageIndex        : this.pageOptions.pageIndex,
						pageSize         : this.pageOptions.pageSize
					}
				};

				this.mixinAxios().get('/api/guest/GetFreebiePackagesPaginated', params)
					.then((paginatedPackages) => {
						this.pageOptions.nrRecords = paginatedPackages.data.nrRecords;
						this.packages  = paginatedPackages.data.entities;
					});
			},
			getSelectedPage(pageIndex) {
				this.getFreebiePackagesPaginated();
			},
			selectParentCategory(idParentCategory) {
				this.selectedParentCategoryID = idParentCategory;
				this.pageOptions.pageIndex = 0;

				this.getFreebiePackagesPaginated();
			},
			getPreviewImage(oPackage) {
				return (oPackage?.images?.[0]?.img500Url);
			},
			isOwned(oPackage) {
				return (this.ownedPackageIDs?.[oPackage.id] != null);
			},
			isUnowned(oPackage) {
				return (!this.isOwned(oPackage));
			},
			getOwnedPackageUrl(oPackage) {
				return `/my-bundles/${oPackage.id}/`;
			},
			getUnownedPackageUrl(oPackage) {
				return (oPackage?.url ?? '');
			},
			getProperPackageUrl(oPackage) {
				return (this.isOwned(oPackage))
					? this.getOwnedPackageUrl(oPackage)
					: this.getUnownedPackageUrl(oPackage);
			},
			classSelected(idParentCategory) {
				return {
					'selected': (idParentCategory == this.selectedParentCategoryID)
				};
			}
		},
		computed: {
			freebieParentCats() {
				// get values from dictionary sorted by name
				var otherCats = Object.values(this.availableFreebieParentCats)
					.sort((a, b) => (a.parentCategoryName < b.parentCategoryName) ? -1 : 1);

				// create 'all' category
				var firstCat = [{
					nrFreebies: otherCats.reduce((acc, x) => acc + x.nrFreebies, 0),
					parentCategoryID: 0,
					parentCategoryName: 'All'
				}];

				// return merged
				return firstCat.concat(otherCats);
			},
			disablePaginator() {
				return this.requestActive;
			}
		}
	}
</script>




<style scoped>
	[v-cloak] {
		display: none;
	}

	.row-header {
		background-image: url(/img/packages/bg-template.png);
		height: 500px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		margin: 0;
	}

	div.row-main {
		max-width: 1200px;
		margin: 0 auto auto auto;
	}

	div.category-button {
		border: 1px solid #dddddd;
		border-radius: 5px;
		padding: 5px 10px;
		display: inline-block;
		margin: 5px;
		cursor: pointer;
		background: #ffffff;
	}

	.category-button.selected {
		background: rgb(224, 231, 255);
	}

	.row-fr-packages {
		padding: 0px 15px 15px 0px;
	}

	.col-fr-package {
		border: 0px solid black;
		padding: 0px;
	}

	.container-fr-package {
		border-radius: 15px;
		border: 1px solid #cccccc;
		margin: 15px 0px 0px 15px;
		position: relative;
	}

	.fr-package-header {
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		background: rgb(67, 56, 202);
		color: white;
	}

	.col-fr-package img {
		width: 100%;
	}

	.col-fr-package p {
		margin: 8px 0px;
	}

	.flex-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.bold {
		font-weight: bold;
	}

	a.always-underline {
		text-decoration: underline;
	}

		a.always-underline:hover {
			text-decoration: underline;
		}

		a.always-underline:focus {
			text-decoration: underline;
		}

		a.always-underline:active {
			text-decoration: underline;
		}




	/* RIBBON */

	.ribbon-wrap {
		position: absolute;
		right: -36px;
		top: 17px;
		width: 130px;
		-ms-transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		border-left: 25px solid transparent;
		border-right: 25px solid transparent;
		border-bottom: 25px solid rgb(224, 231, 255);
		box-shadow: 0px 6px 5px -5px rgba(0, 0, 0, 0.5);
		z-index: 999;
	}

		.ribbon-wrap.a-right {
			-ms-transform: rotate(45deg);
			-webkit-transform: rotate(45deg);
			transform: rotate(45deg);
		}

		.ribbon-wrap .ribbon-content {
			position: absolute;
			left: 17px;
			top: 3px;
			font-size: 15px;
			font-weight: bold;
			line-height: 19px;
			color: #000;
			width: auto;
			text-align: center;
			word-spacing: -1px;
		}

	/* RIBBON */




	/* MEDIA QUERIES */

	/* value hardcoded to centered text in header */
	@media screen and (max-width: 648px) {
		div.row-main {
			margin: -175px auto auto auto;
		}
	}

	/* value hardcoded to centered text in header */
	@media screen and (max-width: 372px) {
		div.row-main {
			margin: -150px auto auto auto;
		}
	}

	/* MEDIA QUERIES */

</style>